import ImsObjectCollection from 'app/shared/collections/ims_object_collection.service';
import { Destructor } from 'app/shared/utilities/Destructor';
import { throttle } from 'lodash';

export function throttleCollectionChanges(
    ms: number,
    collections: Array<ImsObjectCollection>,
    fn,
): Destructor {
    const throttledFn = throttle(fn, ms, {
        leading: false,
        trailing: true,
    });

    const destructor = new Destructor();
    destructor.add(() => throttledFn.cancel());

    for (const c of collections) {
        destructor.add(
            c.addOnChangedListener(() => {
                throttledFn();
            }),
        );
    }

    return destructor;
}
